<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <b-container>
      <b-row align-v="center">
        <b-col cols="auto">
          <v-btn class="btn-return" @click="$router.go(-1)">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i>
            VOLTAR
          </v-btn>
        </b-col>
        <b-col>
          <h1 class="title-pages">CONFIGURAÇÃO DE BOLETO</h1>
        </b-col>
      </b-row>
      <div class="row bg-white p-2">
        <div class="col-md-12 m-0" v-if="false">
          <h3 class="m-0">Campos de Desconto</h3>
          <div class="row">
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <ul>
                  <li>0 - Sem instrução de desconto.</li>
                  <li>1 - Valor Fixo Até a Data Informada.</li>
                  <li>2 - Percentual Até a Data Informada.</li>
                  <li>3 - Valor por Antecipação Dia Corrido.</li>
                  <li>4 - Valor por Antecipação Dia Útil.</li>
                  <li>5 - Percentual Sobre o Valor Nominal Dia Corrido.</li>
                  <li>6 - Percentual Sobre o Valor Nominal Dia Útil.</li>
                  <li>7 - Cancelamento de Desconto.</li>
                </ul>
                <label class="m-0">TituloCodDesconto</label>
                <input
                  type="text"
                  v-model="TituloCodDesconto"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">TituloDataDesconto</label>
                <input
                  type="text"
                  v-model="TituloDataDesconto"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">TituloValorDescontoTaxa</label>
                <input
                  type="text"
                  v-model="TituloValorDescontoTaxa"
                  class="form-control"
                />
                <small class="text-muted"
                  >*Valor irá sair na remessa, para ser descontado
                  automaticamente.
                </small>
              </div>
            </div>
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">TituloValorDesconto</label>
                <input
                  type="text"
                  v-model="TituloValorDesconto"
                  class="form-control"
                />
                <small class="text-muted"
                  >*Valor irá sair na remessa, para ser descontado
                  automaticamente.</small
                >
              </div>
            </div>
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">TituloCodDesconto2</label>
                <input
                  type="text"
                  v-model="TituloCodDesconto2"
                  class="form-control"
                />
                <small class="text-muted"></small>
              </div>
            </div>
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">TituloDataDesconto2</label>
                <input
                  type="text"
                  v-model="TituloDataDesconto2"
                  class="form-control"
                />
                <small class="text-muted"></small>
              </div>
            </div>
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">TituloValorDescontoTaxa2</label>
                <input
                  type="text"
                  v-model="TituloValorDescontoTaxa2"
                  class="form-control"
                />
                <small class="text-muted"></small>
              </div>
            </div>
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">TituloCodDesconto3</label>
                <input
                  type="text"
                  v-model="TituloCodDesconto3"
                  class="form-control"
                />
                <small class="text-muted"></small>
              </div>
            </div>
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">TituloDataDesconto3</label>
                <input
                  type="text"
                  v-model="TituloDataDesconto3"
                  class="form-control"
                />
                <small class="text-muted"></small>
              </div>
            </div>
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">TituloValorDescontoTaxa3</label>
                <input
                  type="text"
                  v-model="TituloValorDescontoTaxa3"
                  class="form-control"
                />
                <small class="text-muted"></small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 m-0">
          <h3 class="m-0">Campos de Juros</h3>
          <div class="row">
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">Juros</label>
                <select v-model="TituloCodigoJuros" class="form-control">
                  <option :value="null">SELECIONE...</option>
                  <option value="1">Valor por dia</option>
                  <option value="2">Taxa mensal</option>
                  <option value="3">Isento</option>
                </select>
                <small class="text-muted"></small>
              </div>
            </div>
            <div class="col-md-6 m-0 p-2" v-if="false">
              <div class="border p-2">
                <label class="m-0">TituloDataJuros</label>
                <input
                  type="text"
                  v-model="TituloDataJuros"
                  class="form-control"
                />
                <small class="text-muted"></small>
              </div>
            </div>
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">Valor Juros</label>
                <input
                  type="text"
                  v-model="TituloValorJuros"
                  class="form-control"
                  @input="campoValor($event.target.value, 'TituloValorJuros')"
                />
                <small class="text-muted"
                  >*Valor irá sair na remessa, para ser calculado
                  automaticamente, quando for pago.</small
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 m-0">
          <h3 class="m-0">Campos de Multa</h3>
          <div class="row">
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">Multa</label>
                <select v-model="TituloCodigoMulta" class="form-control">
                  <option :value="null">SELECIONE...</option>
                  <option value="0">Não registra a multa</option>
                  <option value="1">Valor em Reais (Fixo)</option>
                  <option value="2">
                    Valor em percentual com duas casas decimais
                  </option>
                </select>
                <small class="text-muted"></small>
              </div>
            </div>
            <div class="col-md-6 m-0 p-2" v-if="false">
              <div class="border p-2">
                <label class="m-0">TituloDataMulta</label>
                <input
                  type="text"
                  v-model="TituloDataMulta"
                  class="form-control"
                />
                <small class="text-muted"></small>
              </div>
            </div>
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">Valor Multa Taxa</label>
                <input
                  type="text"
                  v-model="TituloValorMultaTaxa"
                  class="form-control"
                  @input="
                    campoValor($event.target.value, 'TituloValorMultaTaxa')
                  "
                />
                <small class="text-muted"
                  >*Valor irá sair na remessa, para ser calculado
                  automaticamente, quando for pago.</small
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 m-0" v-if="false">
          <h3 class="m-0">Campos de Protesto Automático</h3>
          <div class="row">
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">TituloCodProtesto</label>
                <input
                  type="text"
                  v-model="TituloCodProtesto"
                  class="form-control"
                />
                <small class="text-muted"></small>
              </div>
            </div>
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">TituloPrazoProtesto</label>
                <input
                  type="text"
                  v-model="TituloPrazoProtesto"
                  class="form-control"
                />
                <small class="text-muted"></small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 m-0" v-if="false">
          <h3 class="m-0">Campos de Baixa Automática</h3>
          <div class="row">
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">TituloCodBaixaDevolucao</label>
                <input
                  type="text"
                  v-model="TituloCodBaixaDevolucao"
                  class="form-control"
                />
                <small class="text-muted"></small>
              </div>
            </div>
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">TituloPrazoBaixa</label>
                <input
                  type="text"
                  v-model="TituloPrazoBaixa"
                  class="form-control"
                />
                <small class="text-muted"></small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 m-0">
          <h3 class="m-0">Campos de Mensagens</h3>
          <div class="row">
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">Mensagem 01</label>
                <textarea
                  v-model="TituloMensagem01"
                  class="form-control"
                  cols="3"
                  rows="3"
                ></textarea>
                <small class="text-muted"
                  >Campo onde pode ser informada uma mensagem para ser
                  adicionada ao boleto.</small
                >
              </div>
            </div>
            <div class="col-md-6 m-0 p-2">
              <div class="border p-2">
                <label class="m-0">Mensagem 02</label>
                <textarea
                  v-model="TituloMensagem02"
                  class="form-control"
                  cols="3"
                  rows="3"
                ></textarea>
                <small class="text-muted"
                  >Campo onde pode ser informada uma mensagem para ser
                  adicionada ao boleto.</small
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12"><errors-messages :errors="errors" /></div>
        <div class="col-md-12 text-right">
          <confirmation-dialog
            message-title="CONFIRMAÇÃO"
            message-body="TEM CERTEZA QUE DESEJA SALVAR?"
            open-class="btn-save"
            open-text="SALVAR"
            openLeftIcon="fa-check"
            @yes="save"
          />
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";

import api from "../services/api";

import toast from "../lib/ToastNotification";

import { formatValueOnKeyUp } from "../lib/format";

export default {
  name: "ConfigBoleto",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      errors: [],
      TituloCodDesconto: null,
      TituloDataDesconto: null,
      TituloValorDescontoTaxa: null,
      TituloValorDesconto: null,
      TituloCodDesconto2: null,
      TituloDataDesconto2: null,
      TituloValorDescontoTaxa2: null,
      TituloCodDesconto3: null,
      TituloDataDesconto3: null,
      TituloValorDescontoTaxa3: null,
      TituloCodigoJuros: null,
      TituloDataJuros: null,
      TituloValorJuros: null,
      TituloCodigoMulta: null,
      TituloDataMulta: null,
      TituloValorMultaTaxa: null,
      TituloCodProtesto: null,
      TituloPrazoProtesto: null,
      TituloCodBaixaDevolucao: null,
      TituloPrazoBaixa: null,
      TituloMensagem01: null,
      TituloMensagem02: null,
      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    campoValor(value, campo) {
      if (campo == "TituloValorJuros") {
        this.TituloValorJuros = formatValueOnKeyUp(value);
      } else if (campo == "TituloValorMultaTaxa") {
        this.TituloValorMultaTaxa = formatValueOnKeyUp(value);
      }
    },

    async retrieve() {
      await this.get();
    },

    async get() {
      this.loading = true;

      const response = await api.get("/rest-home/settings/config-boleto");

      const { error, errors, config_boleto } = response.data;

      if (error) {
        this.errors = errors;
      } else {
        this.errors = [];
        if (config_boleto) {
          let {
            TituloCodDesconto,
            TituloDataDesconto,
            TituloValorDescontoTaxa,
            TituloValorDesconto,
            TituloCodDesconto2,
            TituloDataDesconto2,
            TituloValorDescontoTaxa2,
            TituloCodDesconto3,
            TituloDataDesconto3,
            TituloValorDescontoTaxa3,
            TituloCodigoJuros,
            TituloDataJuros,
            TituloValorJuros,
            TituloCodigoMulta,
            TituloDataMulta,
            TituloValorMultaTaxa,
            TituloCodProtesto,
            TituloPrazoProtesto,
            TituloCodBaixaDevolucao,
            TituloPrazoBaixa,
            TituloMensagem01,
            TituloMensagem02,
          } = config_boleto;

          this.TituloCodDesconto = TituloCodDesconto;
          this.TituloDataDesconto = TituloDataDesconto;
          this.TituloValorDescontoTaxa = TituloValorDescontoTaxa;
          this.TituloValorDesconto = TituloValorDesconto;
          this.TituloCodDesconto2 = TituloCodDesconto2;
          this.TituloDataDesconto2 = TituloDataDesconto2;
          this.TituloValorDescontoTaxa2 = TituloValorDescontoTaxa2;
          this.TituloCodDesconto3 = TituloCodDesconto3;
          this.TituloDataDesconto3 = TituloDataDesconto3;
          this.TituloValorDescontoTaxa3 = TituloValorDescontoTaxa3;
          this.TituloCodigoJuros = TituloCodigoJuros;
          this.TituloDataJuros = TituloDataJuros;
          this.TituloValorJuros = TituloValorJuros;
          this.TituloCodigoMulta = TituloCodigoMulta;
          this.TituloDataMulta = TituloDataMulta;
          this.TituloValorMultaTaxa = TituloValorMultaTaxa;
          this.TituloCodProtesto = TituloCodProtesto;
          this.TituloPrazoProtesto = TituloPrazoProtesto;
          this.TituloCodBaixaDevolucao = TituloCodBaixaDevolucao;
          this.TituloPrazoBaixa = TituloPrazoBaixa;
          this.TituloMensagem01 = TituloMensagem01;
          this.TituloMensagem02 = TituloMensagem02;
        }
      }
    },

    async save() {
      try {
        this.loading = true;

        let {
          TituloCodDesconto,
          TituloDataDesconto,
          TituloValorDescontoTaxa,
          TituloValorDesconto,
          TituloCodDesconto2,
          TituloDataDesconto2,
          TituloValorDescontoTaxa2,
          TituloCodDesconto3,
          TituloDataDesconto3,
          TituloValorDescontoTaxa3,
          TituloCodigoJuros,
          TituloDataJuros,
          TituloValorJuros,
          TituloCodigoMulta,
          TituloDataMulta,
          TituloValorMultaTaxa,
          TituloCodProtesto,
          TituloPrazoProtesto,
          TituloCodBaixaDevolucao,
          TituloPrazoBaixa,
          TituloMensagem01,
          TituloMensagem02,
        } = this;

        const data = {
          TituloCodDesconto,
          TituloDataDesconto,
          TituloValorDescontoTaxa,
          TituloValorDesconto,
          TituloCodDesconto2,
          TituloDataDesconto2,
          TituloValorDescontoTaxa2,
          TituloCodDesconto3,
          TituloDataDesconto3,
          TituloValorDescontoTaxa3,
          TituloCodigoJuros,
          TituloDataJuros,
          TituloValorJuros,
          TituloCodigoMulta,
          TituloDataMulta,
          TituloValorMultaTaxa,
          TituloCodProtesto,
          TituloPrazoProtesto,
          TituloCodBaixaDevolucao,
          TituloPrazoBaixa,
          TituloMensagem01,
          TituloMensagem02,
        };

        const response = await api.patch(
          "/rest-home/settings/config-boleto",
          data
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message);
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
ul {
  list-style-type: none;
}
</style>